<form [formGroup]="vehicleRegistrationNumberForm" novalidate>
  <div class="vehicle-registration-number p-3">
    <div class="row">
      <div class="col-lg-4 col-12">
        <div class="d-flex">
          <img
            src="assets/icon/car.svg"
            class="car-image"
            alt="close"
            *ngIf="this.quotes_data?.vehicle_type == 'private_car'"
          />
          <img
            src="assets/icon/bike.svg"
            class="car-image"
            alt="close"
            *ngIf="this.quotes_data?.vehicle_type == 'two_wheeler'"
          />
          <img
            src="assets/icon/cross.svg"
            (click)="onClose()"
            class="cursor-pointer ms-3 cross-btn res"
            alt="close"
          />
        </div>
      </div>
      <div class="col-lg-8">
        <div class="d-flex">
          <span class="title"
            >Enter the vehicle Registration Number to get best and exact
            quotes</span
          >
          <img
            src="assets/icon/cross.svg"
            (click)="onClose()"
            class="cursor-pointer ms-3 cross-btn web"
            alt="close"
          />
        </div>
        <!-- <mat-tab-group class="mt-3" (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedTabIndex"> -->
        <!-- <mat-tab label="Reg. Number" > -->
        <div class="col-lg-9 col-12 mt-2">
          <div class="input-group registration-number-input-wrap">
            <input
              type="text"
              aria-label="Registration number first"
              class="registration-number-first capitalize-text"
              formControlName="registration_number_first"
              readonly
            />
            <input
              type="text"
              aria-label="Registration number second"
              class="registration-number-second capitalize-text"
              formControlName="registration_number_second"
              readonly
            />
            <input
              type="text"
              aria-label="Registration number digit"
              class="form-control registration-number-last-digit"
              placeholder="Enter Registration No."
              formControlName="registration_number_last_digit"
              [maxlength]="8"
              (input)="addHyphen($event)"
              (paste)="onPaste($event)"
              appSpecialCharacterNotAllowed
            />
          </div>
          <ng-container
            *ngIf="
              vehicleRegistrationNumberForm.controls[
                'registration_number_last_digit'
              ]?.touched
            "
          >
            <div
              class="mt-2 error"
              *ngIf="
                vehicleRegistrationNumberForm.controls[
                  'registration_number_last_digit'
                ]?.hasError('required')
              "
            >
              This is a required field.
            </div>
            <div
              class="mt-1 error"
              *ngIf="
                vehicleRegistrationNumberForm
                  .get('registration_number_last_digit')
                  ?.hasError('minlength')
              "
            >
              Minimum length 8
            </div>
            <div
              class="mt-1 error"
              *ngIf="
                vehicleRegistrationNumberForm
                  .get('registration_number_last_digit')
                  ?.hasError('maxlength') &&
                !vehicleRegistrationNumberForm
                  .get('registration_number_last_digit')
                  ?.hasError('pattern')
              "
            >
              Max Length 11
            </div>
            <div
              class="mt-1 error"
              *ngIf="
                vehicleRegistrationNumberForm
                  .get('registration_number_last_digit')
                  ?.hasError('pattern')
              "
            >
              Invalid Registration Number
            </div>
          </ng-container>
          <div *ngIf="showErrorMessage" class="error mt-2">
            Vehicle details not found.
          </div>
          <div class="d-flex justify-content-between mt-2">
            <div class="error-message" *ngIf="twoWheelerJourney">
              <span *ngIf="this.quotes_data?.vehicle_type == 'private_car'"
                >This is a Bike Number</span
              >
              <span *ngIf="this.quotes_data?.vehicle_type == 'two_wheeler'"
                >This is a Car Number</span
              >
            </div>
            <div
              class="reverify"
              *ngIf="twoWheelerJourney"
              (click)="
                loader
                  ? null
                  : getVahaanDetails(vehicleRegistrationNumberForm.valid)
              "
            >
              Reverify
            </div>
          </div>
          <div
            class="d-flex justify-content-between mt-4"
            *ngIf="commercialVehicleMessage"
          >
            <div class="error">This is Commercial Vehicle Number</div>
          </div>
        </div>
        <!-- </mat-tab> -->
        <!-- <mat-tab label="Engine Number" > -->
        <!-- <div class="col-lg-9 col-12 mt-4">
            <mat-form-field appearance="outline" class="mat-input-custom"
                >
                <mat-label>Engine Number</mat-label>
                <input
                  matInput
                  formControlName="engine_number"
                  class="text-uppercase"
                  id-automation="engine_number"
                  minlength="6"
                  maxlength="25"
                />
              </mat-form-field>
          </div> -->
        <!-- <div class="col-lg-9 col-12">
            <mat-form-field appearance="outline" class="mat-input-custom"
                >
                <mat-label>Chassis Number</mat-label>
                <input
                  matInput
                  formControlName="chassis_number"
                  class="text-uppercase"
                  id-automation="chassis_number"
                  minlength="6"
                  maxlength="25"
                />
              </mat-form-field>
          </div> -->
        <!-- <div *ngIf="showErrorMessage" class="error">
            Vehicle Not Found
          </div>
          <div class="d-flex justify-content-between mt-2">
            <div class="error-message" *ngIf="twoWheelerJourney">
              <span *ngIf="this.quotes_data?.vehicle_type == 'private_car'"
                >This is a Bike Number</span
              >
              <span *ngIf="this.quotes_data?.vehicle_type == 'two_wheeler'"
                >This is a Car Number</span
              >
            </div>
            <div
              class="reverify"
              *ngIf="twoWheelerJourney"
              (click)="
                loader
                  ? null
                  : getVahaanDetails(vehicleRegistrationNumberForm.valid)
              "
            >
              Reverify
            </div>
          </div>
          <div
            class="d-flex justify-content-between"
            *ngIf="commercialVehicleMessage"
          >
            <div class="error">This is Commercial Vehicle Number</div>
          </div> -->
        <!-- </mat-tab> -->
        <!-- </mat-tab-group> -->
        <div class="row">
          <!-- <div class="col-lg-3">

              </div>
              <div class="col-lg-9 col-12">
                <div class="text-center mt-2 mb-2">or</div>
                <mat-form-field appearance="outline" class="mat-input-custom"
                    >
                    <mat-label>Engine Number</mat-label>
                    <input
                      matInput
                      formControlName="engine_number"
                      class="text-uppercase"
                      id-automation="engine_number"
                      minlength="6"
                      maxlength="25"
                    />
                  </mat-form-field>
              </div>
              <div class="col-lg-9 col-12">
                <mat-form-field appearance="outline" class="mat-input-custom"
                    >
                    <mat-label>Chasis Number</mat-label>
                    <input
                      matInput
                      formControlName="engine_number"
                      class="text-uppercase"
                      id-automation="engine_number"
                      minlength="6"
                      maxlength="25"
                    />
                  </mat-form-field>
              </div> -->
          <div class="col-lg-9 col-12 mt-2" *ngIf="!twoWheelerJourney">
            <button
              class="submit-btn verify"
              type="submit"
              (click)="
                loader
                  ? null
                  : getVahaanDetails(vehicleRegistrationNumberForm.valid)
              "
              [disabled]="vehicleRegistrationNumberForm.invalid"
            >
              <img
                src="assets/gif/button-loader.gif"
                alt="close"
                class="loader me-2"
                *ngIf="loader"
              />
              Verify & Proceed
            </button>
          </div>
          <div class="col-lg-9 col-12 mt-4" *ngIf="twoWheelerJourney">
            <button
              class="submit-btn verify"
              type="submit"
              (click)="loader ? null : goBack()"
              [disabled]="vehicleRegistrationNumberForm.invalid"
            >
              <img
                src="assets/gif/button-loader.gif"
                alt="close"
                class="loader me-2"
                *ngIf="loader"
              />
              <span *ngIf="this.quotes_data?.vehicle_type == 'private_car'"
                >Get Bike Quotes</span
              >
              <span *ngIf="this.quotes_data?.vehicle_type == 'two_wheeler'"
                >Get Car Quotes</span
              >
            </button>
          </div>
          <div class="note">Note:- Premium might change</div>
        </div>
      </div>
    </div>
  </div>
</form>
